export const POST_LOGIN_REDIRECT_KEY = 'dss2-line.postLoginRedirect';

export function consumePostLoginRedirect(): string | null {
  if (typeof window === 'undefined') return null;
  const stored = window.sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  if (stored) window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  return stored;
}
